import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./style/main.scss";
import App from "./App";
// import "@glideapps/glide-data-grid/dist/index.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
